module.exports = __webpack_public_path__ + "img/qinfo.439da145.webp";